import mqtt from "mqtt";

class mqttHandle {
    constructor(subscribe, loginuser) {
        this.connect = {
            clean: true,
            cleanSession: true,
            connectTimeout: 60000,
            reconnectPeriod: 30000,
            clientId: "screen-channel-" + loginuser + "-" + Number(new Date()).toString(),
            username: "admin",
            password: "airoboy123",
        }
        this.subscription = {
            topic: subscribe,
            qos: 0,
        }
        this.mqttClient = null;
        // 保存已订阅的话题，用于重连后重新订阅
        this.subscribedTopics = new Map(); // topic -> qos
    }

    /**
     * 创建链接
     * @returns client
     */
    createConnect() {
        const { ...options } = this.connect;
        const connectUrl = 'wss://mqtt.techinao.com/mqtt';
        console.log("MQTT连接地址", connectUrl);

        try {
            this._client = mqtt.connect(connectUrl, options);
            console.log("MQTT连接成功");
        } catch (error) {
            console.log("mqtt connect error", error);
        }

        this._client.on("connect", () => {
            console.log("MQTT Connection succeeded!");
            // 连接成功后（重新）订阅所有话题
            this.resubscribeAll();
        });

        this._client.on('reconnect', () => {
            console.log('MQTT 正在重连...');
        });

        this._client.on("error", (error) => {
            console.log("MQTT Connection failed", error);
        });

        this._client.on("close", () => {
            console.log("MQTT 连接已断开");
        });

        this._client.on("offline", () => {
            console.log("MQTT 客户端离线");
        });

        // 初始化订阅话题
        const { topic, qos } = this.subscription;
        if (Array.isArray(topic)) {
            topic.forEach(t => {
                this.subscribedTopics.set(t, qos);
            });
        } else {
            this.subscribedTopics.set(topic, qos);
        }

        this.mqttClient = this._client;
        return this.mqttClient;
    }

    /**
     * 重新订阅所有话题（重连后调用）
     */
    resubscribeAll() {
        if (this.subscribedTopics.size === 0) {
            console.log("没有需要重新订阅的话题");
            return;
        }

        console.log("重新订阅所有话题，共", this.subscribedTopics.size, "个");

        this.subscribedTopics.forEach((qos, topic) => {
            this._client.subscribe(topic, { qos: qos }, (error, res) => {
                if (error) {
                    console.log("MQTT 重新订阅失败:", topic, error);
                    return;
                }
                console.log("MQTT 重新订阅成功:", topic);
            });
        });
    }

    /**
     * 手动订阅话题
     * @param {string|Array} topic - 话题或话题数组
     * @param {number} qos - 服务质量等级
     */
    subscribe(topic, qos = 0) {
        if (!this._client || !this._client.connected) {
            console.log("MQTT 未连接，订阅请求已缓存");
            // 缓存订阅请求，连接成功后会自动订阅
            if (Array.isArray(topic)) {
                topic.forEach(t => this.subscribedTopics.set(t, qos));
            } else {
                this.subscribedTopics.set(topic, qos);
            }
            return;
        }

        const topics = Array.isArray(topic) ? topic : [topic];

        topics.forEach(t => {
            this._client.subscribe(t, { qos: qos }, (error, res) => {
                if (error) {
                    console.log("MQTT 订阅失败:", t, error);
                    return;
                }
                this.subscribedTopics.set(t, qos);
                console.log("MQTT 订阅成功:", t);
            });
        });
    }

    /**
     * 取消订阅话题
     * @param {string|Array} topic - 话题或话题数组
     */
    unsubscribe(topic) {
        const topics = Array.isArray(topic) ? topic : [topic];

        topics.forEach(t => {
            if (this._client && this._client.connected) {
                this._client.unsubscribe(t, (error) => {
                    if (error) {
                        console.log("MQTT 取消订阅失败:", t, error);
                        return;
                    }
                    console.log("MQTT 取消订阅成功:", t);
                });
            }
            this.subscribedTopics.delete(t);
        });
    }

    /**
     * 获取已订阅的话题列表
     * @returns {Array} 已订阅的话题数组
     */
    getSubscribedTopics() {
        return Array.from(this.subscribedTopics.keys());
    }

    /**
     * 断开连接
     * @param {boolean} clearTopics - 是否清除订阅话题缓存
     */
    disconnect(clearTopics = false) {
        if (this._client) {
            this._client.end();
            console.log("MQTT 连接已断开");
        }
        if (clearTopics) {
            this.subscribedTopics.clear();
        }
    }
}

export default mqttHandle;